import React from 'react';
import useCancellationLabel from '../../hooks/useCancellationLabel';
import { Badge } from './CancellationLabel.styles';

interface Props {
  startDate?: string; // YYYY-MM-DD
  postedStartTime?: string; // HH:mm or h:mm A
  postedStartIso?: string; // ISO precise start
  serverLabel?: { text: string; color: string; updatedAt?: string } | null;
}

/**
 * CancellationLabel renders a pill badge that reflects the dynamic priority
 * for a cancelled shift based on time remaining to start.
 */
const CancellationLabel: React.FC<Props> = ({ startDate, postedStartTime, postedStartIso, serverLabel }) => {
  const info = useCancellationLabel({ startDate, postedStartTime, postedStartIso });
  const text = (serverLabel?.text || info?.text);
  const color = (serverLabel?.color || info?.color);
  if (!text || !color) return null;

  const nextChangeText = info && info.msUntilNextChange > 0 && info.nextLabelText
    ? `Changes to ${info.nextLabelText} soon`
    : '';

  const minutes = info ? Math.max(0, Math.round(info.msUntilNextChange / 60000)) : 0;
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  const timeLeft = info && info.msUntilNextChange > 0 && info.nextLabelText
    ? `${hours > 0 ? `${hours}h ` : ''}${mins}m`
    : '';
  const title = info && info.msUntilNextChange > 0 && info.nextLabelText
    ? `Changes to ${info.nextLabelText} in ${timeLeft}`
    : '';

  return (
    <Badge className={'cancellation-badge'} bg={color} aria-label={`${text}${nextChangeText ? ', ' + nextChangeText : ''}`} title={title}>
      {text}
    </Badge>
  );
};

export default CancellationLabel;


